var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 31,
    viewBox: "0 0 60 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 13.2621C60 13.2621 59.7492 13.5129 59.2756 13.9447C56.3641 16.5637 44.9129 26.0784 31.8737 25.8416C19.0295 25.6187 5.04295 17.6921 1.10053 15.296C0.487579 14.9059 0.111447 14.6691 0.0278621 14.6134H0.0139313C0.153239 14.5855 1.11447 14.488 2.47968 13.889C3.27374 13.5407 4.22104 12.9974 5.22405 12.1894C8.02415 9.90478 14.5995 -0.139338 31.7344 -2.97597e-05C46.3757 0.125348 56.6148 9.69581 59.2895 12.4959C59.7632 12.9835 60 13.2621 60 13.2621Z",
    fill: "#E9385E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 13.2621C60 13.2621 59.7492 13.5128 59.2756 13.9447C55.6536 13.0671 45.094 10.7685 34.4091 10.7406C26.8029 10.7545 22.15 12.0919 18.0125 13.29C14.4463 14.3208 11.0611 15.296 6.4639 15.296H5.8788C4.59717 15.2681 2.68865 15.296 1.10053 15.296C0.487579 14.9059 0.111447 14.6691 0.0278621 14.6134H0.0139313C0.153239 14.5855 1.11447 14.488 2.47968 13.889C3.71953 13.889 4.9733 13.889 5.90666 13.889C10.5874 13.9865 13.8472 13.0253 17.6225 11.9387C21.8574 10.7127 26.6078 9.31967 34.4091 9.3336C44.9408 9.36146 55.3471 11.5625 59.2895 12.482C59.7632 12.9695 60 13.2482 60 13.2482V13.2621Z",
    fill: "#382A23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83887 14.1397C1.83887 14.1397 1.96424 14.0979 2.0339 14.0701C1.96424 14.0979 1.90852 14.1258 1.83887 14.1397Z",
    fill: "#FF5D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2895 13.9309C55.0406 12.9279 44.7597 10.7686 34.423 10.7407H34.2977C26.8168 10.7407 22.1361 12.092 18.0125 13.2901C14.4463 14.3209 11.0611 15.31 6.4639 15.31C6.26887 15.31 6.08777 15.31 5.89274 15.31C4.6111 15.2961 2.70258 15.2822 1.10054 15.2961C5.04296 17.6922 19.0434 25.6328 31.8876 25.8557C47.0165 26.1203 60.0139 13.2622 60.0139 13.2622C60.0139 13.2622 59.7493 13.513 59.2895 13.9309Z",
    fill: "#FF5D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 13.262C60 13.262 59.7493 12.9695 59.3035 12.4958C59.7493 12.9556 60 13.262 60 13.262Z",
    fill: "#FF5D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.59902 14.9755C0.487573 14.9059 0.376127 14.8362 0.306473 14.7944C0.390058 14.8502 0.487573 14.9059 0.59902 14.9755Z",
    fill: "#FF5D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08661 15.282C0.91944 15.1845 0.766201 15.087 0.640823 15.0034C0.766201 15.087 0.91944 15.1706 1.08661 15.282Z",
    fill: "#FF5D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4486 26.956C24.4486 26.956 27.4855 29.0039 32.1105 29.0039C36.7356 29.0039 42.5029 26.2734 42.5029 26.2734C42.5029 26.2734 37.8082 31.2049 32.1941 30.8288C26.58 30.4527 24.4625 26.956 24.4625 26.956H24.4486Z",
    fill: "#AD775C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30.8428,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth2);
export default __webpack_public_path__ + "static/media/mouth-2.b8c6b9d1fdcd1ed4a745171c389ada2f.svg";
export { ForwardRef as ReactComponent };